import React, { useState, useMemo, useCallback } from 'react';
import TopNavigation from 'components/ui/TopNavigation';
import QuickActionToolbar from 'components/ui/QuickActionToolbar';
import NotificationAlertBar from 'components/ui/NotificationAlertBar';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

import AccountStatsPanel from './components/AccountStatsPanel';
import AccountFilters from './components/AccountFilters';
import AccountTable from './components/AccountTable';
import AccountPagination from './components/AccountPagination';
import AccountFormModal from './components/AccountFormModal';
import AccountDetailModal from './components/AccountDetailModal';
import MapModal from './components/MapModal';

const MOCK_ACCOUNTS = [
  { id: 1001, name: 'Santos General Merchandise', type: 'Distributor', region: 'NCR', area: 'Metro Manila', salesperson: 'Juan dela Cruz', address: '123 Rizal Ave, Brgy. 123, Tondo', city: 'Manila', province: 'Metro Manila', zipCode: '1000', contactPerson: 'Roberto Santos', contactPhone: '+63 917 123 4567', contactEmail: 'rsantos@sgm.ph', lat: '14.5995', lng: '120.9842', creditLimit: 250000, creditUsedPct: 68, lastSaleAmount: 48500, lastSaleDate: '03/05/2026', paymentTerms: 'Net 30', status: 'Active', salesHistory: [{ date: '03/05/2026', amount: 48500, items: 12, orderId: 'ORD-8821' }, { date: '02/20/2026', amount: 62000, items: 18, orderId: 'ORD-8654' }, { date: '02/05/2026', amount: 35000, items: 9, orderId: 'ORD-8412' }] },
  { id: 1002, name: 'Reyes Sari-Sari Store', type: 'Retail Store', region: 'NCR', area: 'Metro Manila', salesperson: 'Maria Santos', address: '45 Quezon Blvd, Brgy. Pinyahan, QC', city: 'Quezon City', province: 'Metro Manila', zipCode: '1100', contactPerson: 'Lita Reyes', contactPhone: '+63 918 234 5678', contactEmail: 'lreyes@gmail.com', lat: '14.6760', lng: '121.0437', creditLimit: 50000, creditUsedPct: 42, lastSaleAmount: 8200, lastSaleDate: '03/04/2026', paymentTerms: 'COD', status: 'Active', salesHistory: [{ date: '03/04/2026', amount: 8200, items: 5, orderId: 'ORD-8819' }, { date: '02/18/2026', amount: 9500, items: 6, orderId: 'ORD-8640' }] },
  { id: 1003, name: 'Cebu Pacific Distributors', type: 'Distributor', region: 'Visayas', area: 'Cebu', salesperson: 'Pedro Reyes', address: '78 Colon St, Brgy. Parian, Cebu City', city: 'Cebu City', province: 'Cebu', zipCode: '6000', contactPerson: 'Marco Villanueva', contactPhone: '+63 919 345 6789', contactEmail: 'mvillanueva@cpd.ph', lat: '10.3157', lng: '123.8854', creditLimit: 500000, creditUsedPct: 55, lastSaleAmount: 125000, lastSaleDate: '03/03/2026', paymentTerms: 'Net 15', status: 'Active', salesHistory: [{ date: '03/03/2026', amount: 125000, items: 35, orderId: 'ORD-8810' }, { date: '02/15/2026', amount: 98000, items: 28, orderId: 'ORD-8601' }] },
  { id: 1004, name: 'Davao Mega Dealers', type: 'Dealer', region: 'Mindanao', area: 'Davao', salesperson: 'Ana Gomez', address: '22 Ilustre Ave, Brgy. 3-A, Davao City', city: 'Davao City', province: 'Davao del Sur', zipCode: '8000', contactPerson: 'Ernesto Dela Torre', contactPhone: '+63 920 456 7890', contactEmail: 'edelatorre@dmd.ph', lat: '7.1907', lng: '125.4553', creditLimit: 300000, creditUsedPct: 81, lastSaleAmount: 75000, lastSaleDate: '03/02/2026', paymentTerms: 'Net 30', status: 'Active', salesHistory: [{ date: '03/02/2026', amount: 75000, items: 22, orderId: 'ORD-8805' }] },
  { id: 1005, name: 'Iloilo Sub-Dist Network', type: 'Sub-Distributor', region: 'Visayas', area: 'Iloilo', salesperson: 'Carlo Bautista', address: '5 Iznart St, Brgy. Molo, Iloilo City', city: 'Iloilo City', province: 'Iloilo', zipCode: '5000', contactPerson: 'Grace Fernandez', contactPhone: '+63 921 567 8901', contactEmail: 'gfernandez@isn.ph', lat: '10.6969', lng: '122.5644', creditLimit: 150000, creditUsedPct: 33, lastSaleAmount: 32000, lastSaleDate: '03/01/2026', paymentTerms: 'Net 7', status: 'Active', salesHistory: [{ date: '03/01/2026', amount: 32000, items: 10, orderId: 'ORD-8798' }] },
  { id: 1006, name: 'Batangas Prime Retail', type: 'Retail Store', region: 'Luzon', area: 'Batangas', salesperson: 'Juan dela Cruz', address: '100 P. Burgos St, Brgy. Poblacion, Batangas City', city: 'Batangas City', province: 'Batangas', zipCode: '4200', contactPerson: 'Noel Castillo', contactPhone: '+63 922 678 9012', contactEmail: 'ncastillo@bpr.ph', lat: '13.7565', lng: '121.0583', creditLimit: 80000, creditUsedPct: 60, lastSaleAmount: 18500, lastSaleDate: '02/28/2026', paymentTerms: 'Net 15', status: 'Active', salesHistory: [{ date: '02/28/2026', amount: 18500, items: 7, orderId: 'ORD-8790' }] },
  { id: 1007, name: 'Pampanga Wholesale Hub', type: 'Distributor', region: 'Luzon', area: 'Pampanga', salesperson: 'Maria Santos', address: '33 MacArthur Hwy, Brgy. Dolores, San Fernando', city: 'San Fernando', province: 'Pampanga', zipCode: '2000', contactPerson: 'Rosario Manalo', contactPhone: '+63 923 789 0123', contactEmail: 'rmanalo@pwh.ph', lat: '15.0285', lng: '120.6899', creditLimit: 400000, creditUsedPct: 72, lastSaleAmount: 95000, lastSaleDate: '02/27/2026', paymentTerms: 'Net 30', status: 'On Hold', salesHistory: [{ date: '02/27/2026', amount: 95000, items: 30, orderId: 'ORD-8785' }] },
  { id: 1008, name: 'CDO Northern Dealers', type: 'Dealer', region: 'Mindanao', area: 'Cagayan de Oro', salesperson: 'Pedro Reyes', address: '12 Velez St, Brgy. Carmen, CDO', city: 'Cagayan de Oro', province: 'Misamis Oriental', zipCode: '9000', contactPerson: 'Dante Uy', contactPhone: '+63 924 890 1234', contactEmail: 'duy@cnd.ph', lat: '8.4542', lng: '124.6319', creditLimit: 200000, creditUsedPct: 15, lastSaleAmount: 22000, lastSaleDate: '02/25/2026', paymentTerms: 'COD', status: 'Inactive', salesHistory: [{ date: '02/25/2026', amount: 22000, items: 8, orderId: 'ORD-8770' }] },
  { id: 1009, name: 'Makati Premium Stores', type: 'Retail Store', region: 'NCR', area: 'Metro Manila', salesperson: 'Ana Gomez', address: '88 Ayala Ave, Brgy. Bel-Air, Makati', city: 'Makati City', province: 'Metro Manila', zipCode: '1226', contactPerson: 'Sophia Cruz', contactPhone: '+63 925 901 2345', contactEmail: 'scruz@mps.ph', lat: '14.5547', lng: '121.0244', creditLimit: 120000, creditUsedPct: 90, lastSaleAmount: 55000, lastSaleDate: '03/05/2026', paymentTerms: 'Net 7', status: 'Active', salesHistory: [{ date: '03/05/2026', amount: 55000, items: 15, orderId: 'ORD-8822' }] },
  { id: 1010, name: 'Laguna Sub-Network', type: 'Sub-Distributor', region: 'Luzon', area: 'Batangas', salesperson: 'Carlo Bautista', address: '7 National Hwy, Brgy. Bagong Kalsada, Calamba', city: 'Calamba', province: 'Laguna', zipCode: '4027', contactPerson: 'Benny Lim', contactPhone: '+63 926 012 3456', contactEmail: 'blim@lsn.ph', lat: '14.2115', lng: '121.1653', creditLimit: 180000, creditUsedPct: 48, lastSaleAmount: 41000, lastSaleDate: '03/01/2026', paymentTerms: 'Net 15', status: 'Active', salesHistory: [{ date: '03/01/2026', amount: 41000, items: 13, orderId: 'ORD-8800' }] },
  { id: 1011, name: 'Visayas Central Trading', type: 'Dealer', region: 'Visayas', area: 'Cebu', salesperson: 'Pedro Reyes', address: '55 Osmena Blvd, Brgy. Sambag, Cebu City', city: 'Cebu City', province: 'Cebu', zipCode: '6000', contactPerson: 'Tomas Abella', contactPhone: '+63 927 123 4567', contactEmail: 'tabella@vct.ph', lat: '10.3000', lng: '123.8900', creditLimit: 220000, creditUsedPct: 62, lastSaleAmount: 67000, lastSaleDate: '02/26/2026', paymentTerms: 'Net 30', status: 'Active', salesHistory: [{ date: '02/26/2026', amount: 67000, items: 20, orderId: 'ORD-8778' }] },
  { id: 1012, name: 'Mindanao Agri Supplies', type: 'Distributor', region: 'Mindanao', area: 'Davao', salesperson: 'Ana Gomez', address: '30 Quirino Ave, Brgy. Poblacion, Davao City', city: 'Davao City', province: 'Davao del Sur', zipCode: '8000', contactPerson: 'Lourdes Tan', contactPhone: '+63 928 234 5678', contactEmail: 'ltan@mas.ph', lat: '7.2000', lng: '125.4600', creditLimit: 350000, creditUsedPct: 77, lastSaleAmount: 88000, lastSaleDate: '03/04/2026', paymentTerms: 'Net 30', status: 'Active', salesHistory: [{ date: '03/04/2026', amount: 88000, items: 25, orderId: 'ORD-8815' }] },
];

const DEFAULT_FILTERS = {
  search: '', type: 'All Types', region: 'All Regions', area: 'All Areas',
  salesperson: 'All Salespersons', status: 'All Status',
};

const PAGE_SIZE_DEFAULT = 10;

export default function AccountManagement() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [accounts, setAccounts] = useState(MOCK_ACCOUNTS);
  const [sortConfig, setSortConfig] = useState({ key: 'name', dir: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
  const [showForm, setShowForm] = useState(false);
  const [editAccount, setEditAccount] = useState(null);
  const [viewAccount, setViewAccount] = useState(null);
  const [mapAccount, setMapAccount] = useState(null);
  const [showStats, setShowStats] = useState(true);

  const filtered = useMemo(() => {
    let data = [...accounts];
    const s = filters?.search?.toLowerCase();
    if (s) data = data?.filter(a => a?.name?.toLowerCase()?.includes(s) || a?.address?.toLowerCase()?.includes(s) || (a?.city || '')?.toLowerCase()?.includes(s));
    if (filters?.type !== 'All Types') data = data?.filter(a => a?.type === filters?.type);
    if (filters?.region !== 'All Regions') data = data?.filter(a => a?.region === filters?.region);
    if (filters?.area !== 'All Areas') data = data?.filter(a => a?.area === filters?.area);
    if (filters?.salesperson !== 'All Salespersons') data = data?.filter(a => a?.salesperson === filters?.salesperson);
    if (filters?.status !== 'All Status') data = data?.filter(a => a?.status === filters?.status);

    data?.sort((a, b) => {
      let av = a?.[sortConfig?.key], bv = b?.[sortConfig?.key];
      if (typeof av === 'string') av = av?.toLowerCase();
      if (typeof bv === 'string') bv = bv?.toLowerCase();
      if (av < bv) return sortConfig?.dir === 'asc' ? -1 : 1;
      if (av > bv) return sortConfig?.dir === 'asc' ? 1 : -1;
      return 0;
    });
    return data;
  }, [accounts, filters, sortConfig]);

  const totalPages = Math.max(1, Math.ceil(filtered?.length / pageSize));
  const paginated = filtered?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handleSort = useCallback((key) => {
    setSortConfig(prev => ({ key, dir: prev?.key === key && prev?.dir === 'asc' ? 'desc' : 'asc' }));
    setCurrentPage(1);
  }, []);

  const handleFilterChange = (f) => { setFilters(f); setCurrentPage(1); };
  const handleReset = () => { setFilters(DEFAULT_FILTERS); setCurrentPage(1); };

  const handleSave = (acc) => {
    setAccounts(prev => {
      const idx = prev?.findIndex(a => a?.id === acc?.id);
      if (idx >= 0) { const n = [...prev]; n[idx] = { ...prev?.[idx], ...acc }; return n; }
      return [{ ...acc, creditUsedPct: 0, lastSaleAmount: 0, lastSaleDate: '—', salesHistory: [] }, ...prev];
    });
  };

  const handleAction = (action) => {
    if (action === 'add-account') { setEditAccount(null); setShowForm(true); }
  };

  return (
    <div className="min-h-screen bg-background page-gradient-bg">
      <TopNavigation />
      <NotificationAlertBar />
      <QuickActionToolbar onAction={handleAction} />
      <main className="px-4 md:px-6 lg:px-8 py-3 md:py-4 lg:py-6 pb-20 lg:pb-8">
        {/* Page Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
          <div>
            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground">Account Management</h1>
            <p className="font-caption text-sm text-muted-foreground mt-0.5">
              Manage distributors, retail accounts, dealers, and sub-distributors across all territories.
            </p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              iconName={showStats ? 'PanelRightClose' : 'PanelRightOpen'}
              iconPosition="left"
              onClick={() => setShowStats(p => !p)}
            >
              {showStats ? 'Hide Stats' : 'Show Stats'}
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="UserPlus"
              iconPosition="left"
              onClick={() => { setEditAccount(null); setShowForm(true); }}
            >
              Add New Account
            </Button>
          </div>
        </div>

        <div className={`flex gap-5 ${showStats ? 'flex-col xl:flex-row' : ''}`}>
          {/* Main Content */}
          <div className="flex-1 min-w-0 space-y-4">
            {/* Filters */}
            <AccountFilters
              filters={filters}
              onChange={handleFilterChange}
              onReset={handleReset}
              resultCount={filtered?.length}
            />

            {/* Table Card */}
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-4 py-3 border-b border-border">
                <div className="flex items-center gap-2">
                  <Icon name="Table" size={16} color="var(--color-primary)" strokeWidth={2} />
                  <h2 className="font-heading text-sm font-semibold text-foreground">Account Records</h2>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary font-data">
                    {filtered?.length}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Button variant="ghost" size="sm" iconName="Download" iconPosition="left">Export</Button>
                  <Button variant="ghost" size="sm" iconName="Upload" iconPosition="left">Import</Button>
                </div>
              </div>

              <AccountTable
                accounts={paginated}
                onView={(acc) => setViewAccount(acc)}
                onEdit={(acc) => { setEditAccount(acc); setShowForm(true); }}
                onMap={(acc) => setMapAccount(acc)}
                onSort={handleSort}
                sortConfig={sortConfig}
              />

              <AccountPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={filtered?.length}
                pageSize={pageSize}
                onPageChange={setCurrentPage}
                onPageSizeChange={(s) => { setPageSize(s); setCurrentPage(1); }}
              />
            </div>
          </div>

          {/* Stats Panel */}
          {showStats && (
            <div className="xl:w-80 flex-shrink-0">
              <AccountStatsPanel />
            </div>
          )}
        </div>
      </main>
      {/* Modals */}
      <AccountFormModal
        isOpen={showForm}
        onClose={() => { setShowForm(false); setEditAccount(null); }}
        onSave={handleSave}
        editAccount={editAccount}
      />
      <AccountDetailModal
        isOpen={!!viewAccount}
        account={viewAccount}
        onClose={() => setViewAccount(null)}
        onEdit={(acc) => { setViewAccount(null); setEditAccount(acc); setShowForm(true); }}
        onMap={(acc) => { setViewAccount(null); setMapAccount(acc); }}
      />
      <MapModal
        isOpen={!!mapAccount}
        account={mapAccount}
        onClose={() => setMapAccount(null)}
      />
    </div>
  );
}